import { format } from 'date-fns';

import { Anchor, List, Menu, Text } from '@zillow/constellation-10';

import type { UserNotificationsAllNotificationsNotificationWebDto } from '@zg-rentals/ts-rental-manager-api-beta-client';

export type NotificationMenuItemVariant = 'menu' | 'list';

type Props = {
  notificationItem: UserNotificationsAllNotificationsNotificationWebDto;
  onClick(): void;
  variant?: NotificationMenuItemVariant;
};

const NotificationMenuItem = ({ notificationItem, onClick, variant = 'menu' }: Props) => {
  const isRead = notificationItem.status.toUpperCase() === 'READ';

  const subContent = (
    <>
      <br />
      <Text textStyle={`body-xs${isRead ? '' : '-bold'}`}>
        {format(new Date(new Date(Number(notificationItem.createdMs))), 'h:mm a, MMM do')}
      </Text>
    </>
  );

  if (variant === 'list') {
    return (
      <List.Item onClick={onClick} css={{ cursor: 'pointer' }}>
        <Anchor css={{ textStyle: isRead ? 'body-sm' : 'body-sm-bold' }} href={notificationItem.textAndUrl.url}>
          {notificationItem.textAndUrl.text}
        </Anchor>
        {subContent}
      </List.Item>
    );
  }

  return (
    <Menu.Item
      onClick={() => {
        onClick();
        window.location.href = notificationItem.textAndUrl.url;
      }}
    >
      <Menu.ItemLabel css={{ textStyle: isRead ? 'body-sm' : 'body-sm-bold' }}>
        {notificationItem.textAndUrl.text}
        {subContent}
      </Menu.ItemLabel>
    </Menu.Item>
  );
};

export default NotificationMenuItem;
